import React, { useState, useEffect } from 'react';
import $ from 'jquery';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Card, CardContent, Grid, Typography, Avatar, Button } from '@material-ui/core';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import MoneyIcon from '@material-ui/icons/Money';
import BookIcon from '@material-ui/icons/Book';
const useStyles = makeStyles(theme => ({
  root: {
    height: '100%'
  },
  content: {
    alignItems: 'center',
    display: 'flex'
  },
  title: {
    fontWeight: 700
  },
  avatar: {
    backgroundColor: theme.palette.error.main,
    height: 56,
    width: 56
  },
  icon: {
    height: 32,
    width: 32
  },
  difference: {
    marginTop: theme.spacing(2),
    display: 'flex',
    alignItems: 'center'
  },
  differenceIcon: {
    color: theme.palette.error.dark
  },
  differenceValue: {
    color: theme.palette.error.dark,
    marginRight: theme.spacing(1)
  }
}));
const handleClickOpen = () => {
  window.location.href = "/criarDossier"
};
const handleClickOpenEditar = () => {
  window.location.href = "/editarDossier"
};

const Budget = props => {
  const { className, ...rest } = props;

  const classes = useStyles();


  useEffect(() => {

    window.scrollTo({ top: 0, behavior: 'smooth' });


    var path = "http://localhost:8888"
    var path = "https://dossieradmin.maxiglobal.net/api/"
    
  });



  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardContent>
        <Grid
          container
          justify="space-between"
        >
          <Grid item>
            <Typography
              className={classes.title}
              color="textSecondary"
              gutterBottom
              variant="body2"
            >
              Dossiers
            </Typography>
            <Typography
              variant="h3"
              id="lista">
            </Typography>
          </Grid>
          <Grid item>
            <Avatar className={classes.avatar}>
              <BookIcon className={classes.icon} />
            </Avatar>
          </Grid>
        </Grid>

      </CardContent>
      <CardContent>
        <Grid item>
          <Button
            onClick={handleClickOpen}
            color="primary"
            variant="contained"
          >
            Criar Dossier
</Button>
        </Grid>
      </CardContent>
      <CardContent>
        <Grid item>
          <Button
            onClick={handleClickOpenEditar}
            color="primary"
            variant="contained">
            Editar/Finalizar Dossier
</Button>
        </Grid>
      </CardContent>

    </Card>
  );
};

Budget.propTypes = {
  className: PropTypes.string
};

export default Budget;
